<template>
    <el-select
        v-if="tenantName"
        :value="tenantId"
        filterable
        :disabled="!canSwitchTenant"
        size="mini"
        placeholder="请选择租户"
        class="tenant-switch"
        @change="handleChange">
        <el-option
            v-for="item in tenantsList"
            :key="item.id"
            :label="item.name"
            :value="item.id" />
    </el-select>
</template>

<script>
export default {
    name: 'TenantSwitch',
    props: {
        tenantId: {
            type: String,
            default: '',
        },
        tenantName: {
            type: String,
            default: '',
        },
        tenantsList: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        canSwitchTenant() {
            return this.tenantsList.length > 1
        },
    },
    methods: {
        handleChange(value) {
            if (!value || value === this.tenantId) return
            this.$emit('cutTenant', value)
        },
    },
}
</script>

<style lang="scss" scoped>
.tenant-switch {
    width: 150px;
    margin-left: 16px;
    vertical-align: middle;
}
</style>
